module.exports = __webpack_public_path__ + "img/id_ind.dbfeaabb.png";